enum SurveyStatus {
  Open = "Open",
  Completed = "Completed",
}

export default SurveyStatus;
